import { apiAuth, apiResponseType } from ".";

export const getEstablishmentsData = (page: number = 1): apiResponseType =>
  apiAuth.get(`establishments?page=${page}`);

export const registerEstablishmentsData = (data) =>
  apiAuth.postForm("/establishments/store", data) as apiResponseType;
export const deleteEstablishmentsData = (tenid: string) =>
  apiAuth.delete(`establishments/${tenid}/destroy`) as apiResponseType;
export const updateEstablishmentsData = (tenid: string, data) =>
  apiAuth.postForm(`establishments/${tenid}/update`, data) as apiResponseType;

export const getShowEstablishments = (tenid: string) =>
  apiAuth.get(`establishments/${tenid}/show`) as apiResponseType;

export const searchEstablishmentsData = (params: {
  name: string;
}): apiResponseType => apiAuth.get(`establishments?name=${params.name}`);

export const setStatusEstablishments = (tenid: string) =>
  apiAuth.put(`establishments/${tenid}/toggle-status`) as apiResponseType;

export const getSelectEstablishments = () =>
  apiAuth.get(`establishments/select`) as apiResponseType;
